export function useReferralCode() {
  return useCookie("referral-code", {
    maxAge: 60 * 60 * 24 * 60,
  });
}
